import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import { useItem } from './Item.hooks'
import Content from '../../../../components/Content'

const Item = props => {
	const [
		{
			classes,
			image,
			group,
			itemKey,
			mobileAlignment,
			mobileButtonWidth,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonTextKey,
			buttonTextConfig,
			buttonLink,
			buttonAction,
			buttonTextEditable,
		},
		{ handleImageClick, handleTextClick, handleButtonClick, handleClick, handleTextChange, handleButtonTextChange },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<Content
				image={image}
				text={text}
				textConfig={textConfig}
				buttonText={buttonText}
				buttonTextConfig={buttonTextConfig}
				buttonLink={buttonLink}
				buttonAction={buttonAction}
				className={clsx(classes.content, 'cta4-item-content')}
				classes={{ image: classes.image }}
				onClick={handleClick}
				onTextClick={handleTextClick}
				onImageClick={handleImageClick}
				onButtonClick={handleButtonClick}
				textEditable={textEditable}
				onTextChange={handleTextChange}
				buttonTextEditable={buttonTextEditable}
				onButtonTextChange={handleButtonTextChange}
				textKey={textKey}
				buttonTextKey={buttonTextKey}
				mobileAlignment={mobileAlignment}
				mobileButtonWidth={mobileButtonWidth}
			/>
		</ItemBorder>
	)
}
Item.propTypes = {
	group: PropTypes.string.isRequired,
	itemKey: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	mobileAlignment: PropTypes.string,
	mobileButtonWidth: PropTypes.string,
}
export default memo(Item)
